(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/store/assets/reducers/create-team-reducer.js') >= 0) return;  svs.modules.push('/components/marketplace-data/store/assets/reducers/create-team-reducer.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  TEAM_NAME_UPDATE,
  TEAM_CREATE,
  TEAM_CREATE_SUCCESS,
  TEAM_CREATE_FAILURE,
  TEAM_CREATE_NAME_FORBIDDEN,
  EXIT_CREATE_TEAM
} = svs.components.marketplaceData.createTeam.actions;

const reducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    illegalNames: {}
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case TEAM_NAME_UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        teamName: action.teamName,
        validationError: action.validationError,
        backendError: ''
      });
    case TEAM_CREATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        backendError: '',
        loading: true
      });
    case TEAM_CREATE_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        backendError: action.message,
        loading: false
      });
    case EXIT_CREATE_TEAM:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        teamName: '',
        validationError: '',
        backendError: ''
      });
    case TEAM_CREATE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });
    case TEAM_CREATE_NAME_FORBIDDEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        illegalNames: _objectSpread(_objectSpread({}, state.illegalNames), {}, {
          [action.teamName]: action.error
        }),
        validationError: action.teamName === state.teamName ? action.error : state.validationError
      });
    default:
      return state;
  }
};
setGlobal('svs.components.marketplaceData.store.reducers.createTeamReducer', reducer);

 })(window);